import { FC, useEffect } from "react";
import {
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Connection, UsernamePasswordFormValues } from "types";
import { Controller, useForm } from "react-hook-form";

type Props = {
  onChange: (values: UsernamePasswordFormValues) => void;
  initialData?: Connection;
};

const NextConnection: FC<Props> = ({ initialData, onChange }) => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    formState: { errors, isValid },
  } = useForm<UsernamePasswordFormValues>({
    defaultValues: {
      username: initialData?.metadata?.databaseNumber || "",
      password: initialData?.metadata?.oneTimeApiKey || "",
    },
    mode: "onChange", // Validate on each change
  });

  const formValues = watch();

  // Pass form values and validity to parent
  useEffect(() => {
    onChange({
      ...formValues,
      isValid: Boolean(formValues.username && formValues.password) // Simple validation
    });
  }, [formValues, onChange]);

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">
        {t("connection:connection_details")}
      </Typography>

      <Controller
        name="username"
        control={control}
        rules={{
          required: t("alert:missing_value"),
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label={t("connection:database_number")}
            variant="outlined"
            fullWidth
            error={!!errors.username}
            helperText={errors.username ? errors.username.message : ""}
            disabled={!!initialData}
            type="number"
          />
        )}
      />
      
      {!initialData && (
        <Controller
          name="password"
          control={control}
          rules={{
            required: t("alert:missing_value"),
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label={t("connection:one_time_api_key")}
              variant="outlined"
              fullWidth
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ""}
            />
          )}
        />
      )}
    </Stack>
  );
};

export default NextConnection;
